<div class="provider-credential-list-container">
    <h1>Provider Credentials Overview</h1>
    <div *ngIf="loading == true">
        <h2>Loading credential data...</h2>
    </div>
    <div *ngIf="loading == false">
        <div *ngIf="noCredsFound == true">
            <h2>No provider credentials found...</h2>
        </div>
        <div *ngIf="noCredsFound == false">
            <div *ngFor="let cred of credentials">
                <mat-card class="cred-card">
                    <mat-card-header>
                        <mat-card-title>{{cred.Provider}}</mat-card-title>
                        <mat-card-subtitle>Provider Name</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content fxLayout="row">
                        <div class="cred-card-data-item">
                            <div>{{cred.CreatedAt | amTimeAgo}}</div>
                            <div><small>Created</small></div>
                        </div>
                        <div class="cred-card-data-item">
                            <div>{{cred.UpdatedAt | amTimeAgo}}</div>
                            <div><small>Last Updated</small></div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button type="button" mat-button color="primary" [routerLink]="['../credentials', cred.Id]">
                            <mat-icon>folder_open</mat-icon>Open
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
</div>